var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eventReserveBox"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('div',[_c('div',[_vm._v("大人")]),_c('div',{style:({color: _vm.color})},[_vm._v(_vm._s(_vm.AD||0))])]),_c('div',[_c('div',[_vm._v("小孩")]),_c('div',{style:({color: _vm.color})},[_vm._v(_vm._s(_vm.CH||0))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }